import db from '../assets/db/main-db.json'

export const ImagePlacHolder = ({ name, sty }) => {
    return (
        <img src={`https://avatar.iran.liara.run/username?username=${name}`} alt={name} style={sty} />

    )
}
export const getImage = ({ brand, model }) => {
    console.log(`brand = ${brand} and model = ${model}`)
    const brandData = db.brands.find((b) => b.name === brand);
    if (!brandData) return null;

    const modelData = brandData.models.find((m) => m.name === model);
    return modelData ? modelData.imageUrl : null;
};



export const displayFirebaseDate = (created)  => {
    return new Date().toUTCString()
};
export const convertTimestampToDateTime = (timestamp) => {
    if (timestamp && typeof timestamp.seconds === 'number') {
        // Create a Date object from the seconds
        const date = new Date(timestamp.seconds * 1000);

        // Format the date to "Day, DD Mon YYYY"
        const dateOptions = { weekday: 'short', year: 'numeric', month: 'short', day: '2-digit' };
        const formattedDate = date.toLocaleDateString('en-US', dateOptions);

        // Format the time to "HH:MM:SS AM/PM"
        const timeOptions = { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true };
        const formattedTime = date.toLocaleTimeString('en-US', timeOptions);

        // Combine date and time
        return `${formattedDate} ${formattedTime}`;
    }
    return null; // Return null if timestamp is not valid
};
export const convertTime = (timestamp) => {
    if (timestamp && typeof timestamp._seconds === 'number') {
        // Create a Date object from the seconds
        const date = new Date(timestamp._seconds * 1000);

        // Format the date to "Day, DD Mon YYYY"
        const dateOptions = { weekday: 'short', year: 'numeric', month: 'short', day: '2-digit' };
        const formattedDate = date.toLocaleDateString('en-US', dateOptions);

        // Format the time to "HH:MM:SS AM/PM"
        const timeOptions = { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true };
        const formattedTime = date.toLocaleTimeString('en-US', timeOptions);

        // Combine date and time
        return `${formattedDate} ${formattedTime}`;
    }
    return null; // Return null if timestamp is not valid
};